import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

const shortcuts: { keys: string[]; label: string }[] = [
  { keys: ["/"], label: "Focus search (on My recipes)" },
  { keys: ["g", "h"], label: "Go to home" },
  { keys: ["g", "m"], label: "Go to My recipes" },
  { keys: ["?"], label: "Show this dialog" },
  { keys: ["Esc"], label: "Close dialogs & clear search" },
];

const Kbd = ({ children }: { children: React.ReactNode }) => (
  <kbd className="inline-flex min-w-6 items-center justify-center rounded-md border border-border bg-muted px-1.5 py-0.5 font-mono text-[11px] font-medium text-foreground shadow-[inset_0_-1px_0_rgba(0,0,0,0.05)]">
    {children}
  </kbd>
);

export const ShortcutsDialog = ({ open, onOpenChange }: Props) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-sm">
      <DialogHeader>
        <DialogTitle>Keyboard shortcuts</DialogTitle>
        <DialogDescription>
          A few shortcuts to move around faster.
        </DialogDescription>
      </DialogHeader>
      <ul className="mt-2 space-y-2">
        {shortcuts.map((s) => (
          <li
            key={s.label}
            className="flex items-center justify-between gap-3 text-sm"
          >
            <span className="text-foreground">{s.label}</span>
            <span className="flex shrink-0 items-center gap-1">
              {s.keys.map((k, i) => (
                <span key={i} className="flex items-center gap-1">
                  {i > 0 && <span className="text-muted-foreground">then</span>}
                  <Kbd>{k}</Kbd>
                </span>
              ))}
            </span>
          </li>
        ))}
      </ul>
    </DialogContent>
  </Dialog>
);
